/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Форма запроса на восстановление пароля
   */
  app.PasswordResetRequestFormView = app.FormView.extend({
    el: '#password-reset-request-form',
    formName: 'password-reset-request',
    formElement: '.field_input',

    events: {
      'click .button_blue': 'submit',
      'click #remember_password': 'goToLoginForm'
    },

    run: function () {
      app.FormView.prototype.run.apply(this);
      this.defaultNameEn = 'russia';
      this.$buttonBlue = this.$('.button_blue');
      this.$repeatTimer = this.$('.repeat-timer');
      this.$repeatTimer.hide();
      // ошибка восстановления пароля
      this.on('password-reset-request-error', function (e) {
        if (this.isPhone(e.get('entity'))) {
          // восстановление по телефону
          app.recommendationsEvents.trigger('passwordRestoreErrorByPhone');
        } else {
          // восстановление по email'у
          app.recommendationsEvents.trigger('passwordRestoreErrorByEmail');
        }
      }, this);
    },

    submit: function (e) {
      e.preventDefault();
      this.$buttonBlue.prop('disabled', true);
      this.$fields = this.$el.find(this.formElement);
      var attributes = {};

      this.$fields.each(function () {
        attributes[this.name] = $(this).val();
      });

      this.model.save(attributes, {
        success: this.success.bind(this, 'password-reset-request-success'),
        error: this.error.bind(this)
      });
    },

    /**
     * @inheritDoc
     */
    success: function () {
      app.FormView.prototype.success.apply(this, arguments);
      this.$el.hide();
      this.setRequestTimeout();
      if (this.isPhone(this.model.get('entity'))) {
        // восстановление по телефону
        app.recommendationsEvents.trigger('passwordRestoreByPhone');
      } else {
        // восстановление по email'у
        app.recommendationsEvents.trigger('passwordRestoreByEmail');
      }
    },

    /**
     * Таймаут для повторного запроса и обратный отсчет
     */
    setRequestTimeout: function () {
      this.$repeatTimer.show();
      var that = this,
        endTime,
        $elemTimer = this.$('.js-timer-value'),
        cooldown;
      if(this.$buttonBlue.prop('disabled')) {
        $elemTimer.text(app.requestFormCooldown);
        endTime = app.requestFormCooldown;
        cooldown = setInterval(function(){
          endTime = --endTime;
          $elemTimer.text(endTime);
          if (endTime === 0){
            clearInterval(cooldown);
            that.$buttonBlue.removeClass('disabled');
            that.$buttonBlue.prop('disabled', false);
            that.$repeatTimer.hide();
          }
        }, 1000);
      }
    },

    /**
     * Возбуждает событие для перехода к форме авторизации
     */
    goToLoginForm: function () {
      this.trigger('go-to-login-form');
    },

    render: function () {
      this.$el.show();
      var countryFlagModel = app.countryFlag.clone();
      countryFlagModel.set(app.countryFlags[this.defaultNameEn]);
      if (!this.entityInputFormView) {
        // переключение email/телефон
        this.entityInputFormView = new app.EntityInputFormView({
          el: this.$el,
          countryFlagModel: countryFlagModel,
        });
      }
      this.listenTo(this.entityInputFormView, 'switch-entity', this.clearErrors);
    },

    /**
     * Заполнение ошибок
     * @param {arr} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      this.$buttonBlue.prop('disabled', false);
      var that = this;
      var $errorSpan;

      errors.forEach(function (error) {
        $errorSpan = $('#' + that.formName + '-' + error.field + '-error');
        $errorSpan.text(error.message);
        $errorSpan.show();
        $('#' + that.formName + '-' + error.field).parent().addClass('invalid');
      });

      // вызываем событие рекомендаций
      app.recommendationsEvents.trigger('passwordRestoreError');
    },

    /**
     * Очистка ошибок
     */
    clearErrors: function () {
      this.$fields.each(function () {
        $(this).parent().removeClass('invalid');
      });
      this.$el.find('.invalid_message').text('').hide();
    },

    error: function (model, response) {
      app.FormView.prototype.error.call(this, model, response);
      this.trigger('password-reset-request-error', this.model);
    },

    /**
     * Может ли строка быть номером телефона.
     *
     * @param str
     * @returns {boolean}
     */
    isPhone: function (str) {
      return (new RegExp(/^\+?[0-9]+$/)).test(str);
    }
  });
})(jQuery);

}.call(window));